exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".pt-switch[data-v-4acfa4e6]{padding-top:20px}", "", {"version":3,"sources":["/vercel/path0/src/pages/ProductCategory.vue"],"names":[],"mappings":"AACA,4BACE,gBAAkB,CACnB","file":"ProductCategory.vue","sourcesContent":["\n.pt-switch[data-v-4acfa4e6] {\n  padding-top: 20px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4acfa4e6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ProductCategory.vue
// module id = 614
// module chunks = 9